module.exports = __webpack_public_path__ + "media/images/logo_coin-bc3ca25817aa07a6124976fb1bf21dbb.png";